import { LAYOUTS, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, TextAlignTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../../routes';
import { ACTION } from './types';
import { changePanNo, confirmPan } from './actions';
import { heightMap } from '../../../../configs/height';
export const template = (name, panNumber, dob, mobileNumber, emailId) => {
    return {
        layout: {
            id: ROUTE.CO_BORROWER_PAN_CONFIRM_NAME,
            type: LAYOUTS.MODAL,
            style: {
                height: heightMap[ROUTE.CO_BORROWER_PAN_CONFIRM_NAME],
            },
            widgets: [{ id: 'stack_root', type: WIDGET.STACK }],
        },
        datastore: {
            stack_root: {
                justifyContent: StackJustifyContent.center,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    { id: 'space0', type: WIDGET.SPACE },
                    { id: 'title', type: WIDGET.TEXT },
                    { id: 'title_space', type: WIDGET.SPACE },
                    { id: "panViewCard", type: WIDGET.PAN_VIEW_CARD },
                    { id: 'wrong_space', type: WIDGET.SPACE },
                    { id: "yesConfirmButton", type: WIDGET.BUTTON },
                    { id: "space12", type: WIDGET.SPACE },
                    { id: "editPanButton", type: WIDGET.BUTTON },
                    { id: 'title_space', type: WIDGET.SPACE },
                ],
            },
            space0: { size: SizeTypeTokens.MD },
            title: {
                label: `Confirm PAN details`,
                fontSize: FontSizeTokens.LG,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '700',
                textAlign: TextAlignTokens.center,
                lineHeight: 24,
            },
            title_space: { size: SizeTypeTokens.XL },
            description: {
                label: `This PAN belongs to`,
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                textAlign: TextAlignTokens.center,
                lineHeight: 24,
            },
            name: {
                label: `${name}`,
                fontSize: FontSizeTokens.MD,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '700',
                textAlign: TextAlignTokens.center,
                lineHeight: 24,
            },
            confirm: {
                id: 'bt_coBorrowerConfirmPanScreen_continue',
                label: `Continue`,
                fontSize: FontSizeTokens.SM,
                type: ButtonTypeTokens.LargeFilled,
                width: ButtonWidthTypeToken.FULL,
                action: {
                    type: ACTION.CONFIRM_PAN,
                    payload: {
                        panNumber,
                        dob,
                        mobileNumber,
                        emailId,
                    },
                    routeId: ROUTE.CO_BORROWER_PAN_CONFIRM_NAME,
                },
            },
            wrong_space: { size: SizeTypeTokens.XXXL },
            confirm_stack: {
                type: StackType.row,
                widgetItems: [
                    { id: 'wrong1', type: WIDGET.TEXT },
                    { id: 'wrong2', type: WIDGET.TEXT },
                ],
                action: {
                    type: ACTION.CHANGE_PAN_NO,
                    routeId: ROUTE.CO_BORROWER_PAN_CONFIRM_NAME,
                    payload: {},
                },
            },
            wrong1: {
                label: 'PAN details don’t match? ',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Night,
            },
            wrong2: {
                id: 'txt_coBorrowerConfirmPanScreen_enterPanAgain',
                label: 'Enter PAN again',
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Primary_100,
                fontWeight: '600',
            },
            spaceBottom: { size: SizeTypeTokens.XL },
            panViewCard: {
                name: `${name}`,
                panNumber: `${panNumber}`
            },
            yesConfirmButton: {
                id: 'bt_coBorrowerConfirmPanScreen_continue',
                loading: false,
                type: ButtonTypeTokens.LargeFilled,
                width: ButtonWidthTypeToken.FULL,
                label: "Yes, I confirm",
                fontSize: FontSizeTokens.SM,
                fontFamily: FontFamilyTokens.Inter,
                action: {
                    type: ACTION.CONFIRM_PAN,
                    payload: {
                        panNumber,
                        dob,
                        mobileNumber,
                        emailId,
                    },
                    routeId: ROUTE.CO_BORROWER_PAN_CONFIRM_NAME,
                },
            },
            space12: {
                size: SizeTypeTokens.LG
            },
            editPanButton: {
                id: 'bt_coBorrowerConfirmPanScreen_enterPanAgain',
                type: ButtonTypeTokens.LargeSoftFilled,
                width: ButtonWidthTypeToken.FULL,
                label: "Edit PAN details",
                fontSize: FontSizeTokens.SM,
                fontFamily: FontFamilyTokens.Inter,
                action: {
                    type: ACTION.CHANGE_PAN_NO,
                    routeId: ROUTE.CO_BORROWER_PAN_CONFIRM_NAME,
                    payload: {},
                },
            },
        },
    };
};
export const coBorrowerPANConfirmMF = {
    onLoad: async (_, { name, panNumber, dob, mobileNumber, emailId }) => {
        return Promise.resolve(template(name, panNumber, dob, mobileNumber, emailId));
    },
    actions: {
        [ACTION.CONFIRM_PAN]: confirmPan,
        [ACTION.CHANGE_PAN_NO]: changePanNo,
    },
};
